
import { Link, NavLink } from 'react-router';
import {
	LayoutDashboard,
	CalendarDays,
	UsersRound,
	Building2,
	UserRound,
	CarFront,
	Tags,
	SlidersHorizontal,
	BadgePercent,
	ShieldCheck
} from 'lucide-react';

const menu = [
	{
		title: 'Principal',
		items: [
			{ label: 'Dashboard', to: '/', icon: LayoutDashboard },
			{ label: 'Rezervări', to: '/reservations', icon: CalendarDays },
			{ label: 'Clienți', to: '/customers', icon: UsersRound },
			{ label: 'Companii', to: '/companies', icon: Building2 },
			{ label: 'Șoferi', to: '/drivers', icon: UserRound }
		]
	},
	{
		title: 'Flotă',
		items: [
			{ label: 'Mașini', to: '/fleet/vehicles', icon: CarFront },
			{ label: 'Mărci', to: '/fleet/makes', icon: Tags }
		]
	},
	{
		title: 'Setări',
		items: [
			{ label: 'Generale', to: '/settings/general', icon: SlidersHorizontal },
			{ label: 'Tarife', to: '/settings/pricing', icon: BadgePercent },
			{ label: 'Utilizatori', to: '/settings/users', icon: ShieldCheck }
		]
	}
];

const linkClass = ({ isActive }) => [
	'flex min-h-11 items-center gap-3 rounded-xl px-3.5 py-2.5 text-sm font-medium outline-none transition-colors focus-visible:ring-2 focus-visible:ring-brand-500',
	isActive
		? 'bg-brand-500 text-[#171717] shadow-[0_6px_20px_rgba(255,186,3,0.12)]'
		: 'text-white/75 hover:bg-white/[0.08] hover:text-white'
].join(' ');

export default function AppSidebar({ onNavigate }) {
	return (
		<div className="relative flex h-dvh flex-col overflow-hidden bg-[#0c0d0f] text-white">
			<div className="pointer-events-none absolute inset-x-0 top-0 h-56 bg-[radial-gradient(ellipse_at_top_left,rgba(255,186,3,0.08),transparent_70%)]" />

			<div className="relative flex min-h-24 shrink-0 items-center border-b border-white/[0.08] px-6 pr-16">
				<Link to="/" onClick={onNavigate} aria-label="Dashboard" className="block rounded-md outline-none focus-visible:ring-2 focus-visible:ring-brand-500">
					<img src="/assets/imgs/logo.svg" alt="Ride app" className="block h-auto w-44 max-w-full" />
				</Link>
			</div>

			<nav aria-label="Navigare principală" className="relative min-h-0 flex-1 space-y-8 overflow-y-auto overscroll-contain px-3 py-7">
				{menu.map(group => (
					<div key={group.title}>
						<h2 className="mb-3 px-3.5 text-[11px] font-bold uppercase tracking-[0.14em] text-white/45">
							{group.title}
						</h2>

						<ul className="space-y-1">
							{group.items.map(({ label, to, icon: Icon }) => (
								<li key={to}>
									<NavLink to={to} end={to === '/'} onClick={onNavigate} className={linkClass}>
										<Icon size={18} strokeWidth={1.8} aria-hidden="true" />
										<span className="flex-1">{label}</span>
									</NavLink>
								</li>
							))}
						</ul>
					</div>
				))}
			</nav>

			<div className="relative shrink-0 border-t border-white/[0.08] px-6 py-5">
				<div className="flex items-center gap-2 text-xs font-medium text-white/45">
					<span className="size-1.5 rounded-full bg-brand-500" />
					Platformă de administrare
				</div>
			</div>
		</div>
	);
}